import sanitizeHtml from "sanitize-html";
import sanitizeOptions from "../config/sanitize";

export default {
  install: Vue => {
    Vue.directive("html-sanitize", (el, binding) => {
      el.innerHTML = sanitizeHtml(binding.value, sanitizeOptions);
    });
  }
};
